export default __webpack_public_path__ + "static/media/filter.84a487c3.png";